import _ from 'lodash'

export default {
	debugObject(_target) {
		var arr = [];
		for (var i in _target) {
			if (_target.hasOwnProperty(i)) {
				arr[i] = [_target[i]];
			}
		}
		console.table(arr);
	},
	PercentValues(value, isAddSub, max = 100) {
		let res = (isAddSub) ? value + 1 : value - 1;

		if (res > max)
			res = max;

		if (res <= 0)
			res = 0;

		return _.round(res, 1);

	},
	Flow(from, to, value) {
		/*
			{ name: 'l/s' },
			{ name: 'CFM' },1 l/s > CFM = 2.11888 (0.471947)
			{ name: 'm³/h' }, 1 m3/h = 0.277778 L/s; 1 L/s = 3.6 m3/h
			{ name: 'm³/min' } 1 I/s > m³/min = 0.06 (16.666667)
		*/
		let res = value;

		//from 0 and back
		if (from === 0 && to === 1)
			res = value * 2.11888;

		if (from === 1 && to === 0)
			res = _.round(value * 0.471947, 2);

		if (from === 0 && to === 2)
			res = value * 3.6;

		if (from === 2 && to === 0)
			res = _.round(value * 0.277778, 2);

		if (from === 0 && to === 3)
			res = value * 0.06;

		if (from === 3 && to === 0)
			res = _.round(value * 16.666667, 2);

		//from 1 and back
		if (from === 1 && to === 2) {
			res = _.round(value * 0.471947, 2); //to L/s
			res *= 3.6;
		}
		if (from === 2 && to === 1) {
			res = _.round(value * 0.277778, 2); //to L/s
			res *= 2.11888;
		}
		if (from === 1 && to === 3) {
			res = _.round(value * 0.471947, 2); //to L/s
			res *= 0.06;
		}
		if (from === 3 && to === 1) {
			res = _.round(value * 16.666667, 2); //to L/s
			res *= 2.11888;
		}

		//from 2 and back
		if (from === 2 && to === 3) {
			res = _.round(value * 0.277778, 2); //to L/s
			res *= 0.06;
		}
		if (from === 3 && to === 2) {
			res = _.round(value * 16.666667, 2) //to L/s
			res *= 3.6;
		}

		return res;
	},
	Pressure(from, to, value) {
		/*
			1 bar = 14.5038 psi;
			1 psi = 0.0689476 bar
			{ name: 'bar' },
			{ name: 'psi' },
		*/
		let res = value;

		if (from === 0 && to === 1)
			res = value * 14.5038;

		if (from === 1 && to === 0)
			res = value * 0.0689476;

		// console.log('\n*Pressure value in:' + value);
		// console.log({
		// 	 res: res,
		//   resround: _.round(res, 1)
		// })
		return res;

	},
	TemperatureDelta(from, to, value) {
		/*
			°F =  °C * 9/5 + 32
			°C = (°F -32)/(9/5)
		
			{ name: '°C' },
			{ name: '°F' },
		*/
		let res = value;

		if (from === 0 && to === 1)
			res = value * 9 / 5

		if (from === 1 && to === 0)
			res = value / (9 / 5);

		return res;
	},
	Temperature(from, to, value) {
		/*
			°F =  °C * 9/5 + 32
			°C = (°F -32)/(9/5)
		
			{ name: '°C' },
			{ name: '°F' },
		*/
		let res = value;

		if (from === 0 && to === 1)
			res = value * 9 / 5 + 32

		if (from === 1 && to === 0)
			res = (value - 32) / (9 / 5);

		return res;

	},
	CoolingWaterFlow(from, to, value, d = 2) {
		/*
			1 L/s =   15.850323 gal/min
			1 gal/min = 0.06309 L/s
			{ name: 'l/s' },
			{ name: 'gpm' },
		*/

		let res = value;

		if (from === 0 && to === 1)
			res = value * 15.850323

		if (from === 1 && to === 0)
			res = value * 0.06309;

		return res;

	},
	CoolingWaterInput(from, to, value) {
		/*
			{ name: 'Flow' },
			{ name: 'Delta T' },}
		*/
	},
	toKelvinDeltaT(fromIndex, value) {
		//0 °C
		//1 °F
		let res = value;
		//console.log("toKelvinDeltaT", fromIndex);
		if (fromIndex === 1) {
			res = value * (5 / 9);
		}
		return _.round(res, 2);

	},
	toKelvin(fromIndex, value) {
		//0 °C
		//1 °F
		let res = value;

		if (fromIndex === 0)
			res = value + 273.15; //to K

		if (fromIndex === 1) {
			res = (value - 32) / (9 / 5) //°F to °C
			res += 273.15; //to K
		}
		return res;
	},
	fromKelvin(toIndex, value) {
		//0 °C
		//1 °F
		let res = value;

		if (toIndex === 0) // to °C
			res = value - 273.15;

		if (toIndex === 1) {
			res = value - 273.15; // to °C
			res = res * 9 / 5 + 32; // to °F
		}
		return res;
	},
	toPascal(fromIndex, value) {
		//0 bar
		//1 psi

		let res = value;

		if (fromIndex === 0) // from Bar to PA
			res = value * 100000;

		if (fromIndex === 1) // from Psi to PA
		{
			res = value * 0.0689476; //form Psi to bar
			res = res * 100000; //from bar to PA	
		}
		return res;
	},
	toPascal_a(fromIndex, value, referenceBarA) {
		//0 bar
		//1 psi
		let res = value;
		if (fromIndex === 1)
			res = _.round(value * 0.0689476, 1);

		let ref = referenceBarA;
		if (fromIndex === 1)
			ref = _.round(referenceBarA * 0.0689476, 1);

		const result = res * 1e5 + ref * 1e5;


		// console.log('\n*toPascal_a value in:' + value);
		// console.log({
		// 	value: value,
		// 	res: res,
		// 	referenceBarA: referenceBarA,
		// 	ref: ref,
		// 	result: result,
		// 	'res * 1e5': res * 1e5,
		// 	'ref * 1e5': ref * 1e5
		// })


		return result;
	},
	fromPascal_a(toIndex, value, referenceBarA, d) {
		//0 bar
		//1 psi
		
		const referenceBarAToPA = (toIndex === 0) ? referenceBarA * 100000 : (referenceBarA /14.5038)*100000 ;
		const PaToBar = (value - referenceBarAToPA) * 0.00001;//(value - 1 * 1e5) / 1e5;
		const PaToPSI = (value - referenceBarAToPA) / 6894.757293168;
		let res = PaToBar;
		if (toIndex === 1)
			res = PaToPSI;

/*
		const obj = {
			value: value,
			toIndex: toIndex,
			referenceBarAToPA : referenceBarAToPA,
			referenceBarA: referenceBarA,
			PaToBar: PaToBar,
			PaToPSI: PaToPSI,
			result: res
		}
		this.debugObject(obj);
*/
		return res;
	},
	fromPascal(toIndex, value, d = 2) {
		//0 bar
		//1 psi

		let res = value;

		if (toIndex === 0) // from PA to bar
			res = value / 100000;

		if (toIndex === 1) // from PA to Psi
		{
			res = value / 100000; // from PA to bar	
			res = res * 14.5038; //form bar to Psi	

		}
		return res;
	},
	getReportvalue(unitType, unitObj, value ,referencePressure = 1) {
		let res = value;
		let decimalstemp = 2;
		let decimalsPressure = 2;
		let decimalsFlow = 2;

		switch (unitType) {
			case 'Temperature':
				res = _.round( this.fromKelvin(unitObj.selected, value) ,decimalstemp ) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'Pressure':
				res = _.round( this.fromPascal_a(unitObj.selected, value, referencePressure, 3) ,decimalsPressure) + ' ' + unitObj.items[unitObj.selected].name + '(g)';
				break;
			case 'PressureNotA':
				res = _.round( this.fromPascal(unitObj.selected, value, 3) ,decimalsPressure ) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'Flow':
				res = _.round( this.Flow(0, unitObj.selected, value / 0.001) ,decimalsFlow)  + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'WaterFlow':
				res = _.round( this.CoolingWaterFlow(0, unitObj.selected, value / 0.001, decimalsFlow)  ,decimalsFlow) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			//calc
			default:
				res = _.round( value , decimalstemp)  + ' ' + unitObj.items[unitObj.selected].name;
				break;
		}
		return res;
	}
}


// WEBPACK FOOTER //
// ./src/convert.service.js